import React from "react";
import { TextField } from "@mui/material";

/**
 * Drop-in replacement for MUI TextField that trims leading/trailing whitespace
 * from the value when the user leaves the field (onBlur).
 * All props are forwarded to TextField unchanged.
 */
export default function TrimTextField({ onChange, onBlur, ...props }) {
  const handleBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value && onChange) {
      onChange({ ...e, target: { ...e.target, value: trimmed } });
    }
    if (onBlur) onBlur(e);
  };

  return <TextField {...props} onChange={onChange} onBlur={handleBlur} />;
}
